import { render, staticRenderFns } from "./DownlineRepSendInfo.vue?vue&type=template&id=d4c2f624&"
import script from "./DownlineRepSendInfo.vue?vue&type=script&lang=js&"
export * from "./DownlineRepSendInfo.vue?vue&type=script&lang=js&"
import style0 from "./DownlineRepSendInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports